/** 订单详情
 * 有user_id则直接使用user_id, 没有则需要登录
 * **/

import './index.less';
import React, {useEffect, useState} from 'react';
import queryString from 'query-string';
import {fetchQuestionnaireCouponList, receiveQuestionnaireCoupon, QueryTsCouponRecord} from '@/store/api/coupon';
import {reciveCouponNew, queryReviceCouponRecord} from '@/store/api/comment';
import {Result, Icon, Toast} from 'antd-mobile-v2';
import {storage, getEnv, locationTo} from '@utils/tools';
function QuestionnaireCoupons(props) {
  const [coupons, setCoupons] = useState([]);
  const [finish, setFinish] = useState(false);
  const {user_id, oneid, token, awr_id, deal_id, source} = queryString.parse(props.location.search);
  const {id} = props.match.params;
  const [isCan, setIsCan] = useState(false);
  const [serviceType, setServiceType] = useState('就诊评价');
  const [noCanMsg, setNoCanMsg] = useState('');
  const [isMP, setMP] = useState(source === 'mp');
  
  useEffect(() => {
    document.title = '固生堂';
    if (token == '45951b7dac4e4b6bb9dd5a3a2b14aa11' && (!deal_id || deal_id == 'undefined')) { // 点评没有订单号的时候不需要发券
      setIsCan(false);
      setServiceType('服务评价')
    } else {
      getQuestionnaireCouponList({user_id: oneid, oneid, token, awr_id, deal_id: deal_id || ''});
    }
  }, [user_id, token, awr_id, deal_id, oneid]);

  const getQuestionnaireCouponList = async data => {
    Toast.loading('加载中...', 30000);
    let next = true;
    if (token == '45951b7dac4e4b6bb9dd5a3a2b14aa11') {
      setIsCan(false);
      // const res = await queryReviceCouponRecord({ deal_id: deal_id, user_id: user_id || oneid});
      // if (res.code == 200 && res.data && res.data.length) {
      //   if (res.data && res.data.length) {
      //     setIsCan(false);
      //     setNoCanMsg('您已经领取过优惠券');
      //     Toast.fail(`您已经领取过优惠券`);
      //     next = false;
      //     return;
      //   }
      // }
    } else {
      const json0 = await QueryTsCouponRecord(data);
      console.log(json0);
      if (json0.data.length) {
        setIsCan(false);
        setNoCanMsg('您已经领取过优惠券');
        Toast.fail(`您已经领取过优惠券`);
        next = false;
        return;
      }
    }
    if (!next) return; // 已经领取过券就不在查询
    const json = await fetchQuestionnaireCouponList(data);
    Toast.hide();
    if (json.isOK) {
      if (token == '45951b7dac4e4b6bb9dd5a3a2b14aa11') {
        setCoupons([]);
        setIsCan(false);
      } else {
        if (json.data && json.data.length) {
          setIsCan(true);
        } else {
          setIsCan(false);
          setNoCanMsg(json.message || json.detail || '');
        }
        setCoupons(json.data);
      }
    } else {
      setIsCan(false)
      setNoCanMsg(json.message || json.detail);
      Toast.fail(`错误[${json.status}] ${json.message || json.detail}`);
    }
  };
  const handleReceiveQuestionnaireCoupon = async data => {
    Toast.loading('领取中...', 30000);
    const params = {
      coupon_id: '1',
      group_id: data.group_id,
      user_id: user_id || oneid,
      deal_id: deal_id || ''
    };
    try {
      const json = await receiveQuestionnaireCoupon(params);
      Toast.hide();
      if (json.isOK) {
        setFinish(true);
        setTimeout(()=>{
          getResult()
        }, 2000)
      } else {
        Toast.fail(`错误[${json.status}] ${json.message || json.detail}`);
      }
    } catch (e) {
      Toast.fail(`错误[${e}]`);
    }
  };
  const onGetCoupon = async (coupon, idx) => {
    Toast.loading('领取中...', 30000);
    const {code, message} = await reciveCouponNew({
      coupon_id: '1',
      num: '1',
      group_id: coupon.group_id,
      user_id: user_id || oneid,
      deal_id: deal_id,
      
    });
    if (code === 200) {
      Toast.hide();
      setFinish(true);
      setTimeout(()=>{
        getResult()
      }, 2000)
    } else {
      Toast.fail(message);
    }
  };
  const getResult = () => {
    getEnv(res => {
      if (res == 'miniprogram') {
        let wx = window.wx || {};
        if (isMP) {
          wx.miniProgram.switchTab({
            url: `/pages/user/index`, //跳转到小程序个人页
          });
        } else {
          wx.miniProgram.switchTab({
            url: `/pages/userCenter/index`, //跳转到omo小程序个人页
          });
        }
      } else if (res == 'iOSApp') {
        window.webkit.messageHandlers.jsToAppPopRootVC.postMessage({});
      } else if (res == 'androidApp') {
        if (window.android) {
          window.android.jsToAppPopRootVC(
            JSON.stringify({})
          );
        }
      } else if (res == 'h5') {
        locationTo(location.origin + '/usercenter');
      } else {
        locationTo(location.origin + '/usercenter');
      }
    })
  }
  const onGetCouponFun = (d) => {
    if (token == '45951b7dac4e4b6bb9dd5a3a2b14aa11') {
      // onGetCoupon(d)
    } else {
      handleReceiveQuestionnaireCoupon(d)
    }
  }
  return (
    <div className="QuestionnaireCoupons">
      <div className="QuestionnaireCoupons_top">
        <div className="QuestionnaireCoupons_top_line1">
          <Icon type="check-circle" style={{fill: '#fff', marginRight: '12px'}} />
          提交成功
        </div>
        <div className="QuestionnaireCoupons_top_line2">谢谢您参与{serviceType}</div>
        {
          isCan ? (
            <div className="QuestionnaireCoupons_top_line2">我们为您准备了一点心意（三选一）</div>
          ) : (
            <div className="QuestionnaireCoupons_top_line2">{noCanMsg}</div>
          )
        }
        
      </div>
      {finish ? (
        <Result
          img={<Icon type="check-circle" style={{fill: '#1F90E6'}} size="lg" />}
          title="领取成功"
          message="您已经成功领取优惠券"
        />
      ) : (
          isCan ? (
            <div className="QuestionnaireCoupons_middle">
              <div className="QuestionnaireCoupons_middle_title">领取优惠券（三选一）</div>
              <div className="QuestionnaireCoupons_middle_list">
                {coupons.map((d, i) => (
                  <div key={i} className="QuestionnaireCoupons_middle_list_item">
                    <div className="top">
                      <div className="QuestionnaireCoupons_middle_list_item_title">优惠券</div>
                      <div className="QuestionnaireCoupons_middle_list_item_content">{d.coupon_name}</div>
                    </div>
                    <div className="bottom">
                      <div
                        className="QuestionnaireCoupons_middle_list_item_btn"
                        onClick={() => {
                          onGetCouponFun(d)
                        }}
                      >
                        点击领取
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : null
      )}
    </div>
  );
}

export default QuestionnaireCoupons;
